import * as THREE from 'three';
import { extrudeSettings } from '../../../../../../../utils/Functions';

export const WindowModel = ({ modelWidth, modelHeight, doorColor, glassTexture }) => {
    const offset = 0.05

    const outerModel = () => {
        const model = new THREE.Shape();
        model.moveTo(-modelWidth / 2, modelHeight / 2);
        model.lineTo(-modelWidth / 2, -modelHeight / 2);
        model.lineTo(modelWidth / 2, -modelHeight / 2);
        model.lineTo(modelWidth / 2, modelHeight / 2);
        model.closePath();

        const deviation = 0.001
        
        const hole = new THREE.Path();
        hole.moveTo(-(modelWidth / 2 - deviation), -(modelHeight / 2 - deviation));
        hole.lineTo(-(modelWidth / 2 - deviation), (modelHeight / 2 - deviation));
        hole.lineTo((modelWidth / 2 - deviation), (modelHeight / 2 - deviation));
        hole.lineTo((modelWidth / 2 - deviation), -(modelHeight / 2 - deviation));
        hole.closePath();

        model.holes.push(hole);

        return model;
    }

    const innerModel = () => {
        const deviation = 0.3

        const model = new THREE.Shape();
        model.moveTo(-(modelWidth / 1.6 - deviation), -(modelHeight / 1.6 - deviation));
        model.lineTo(-(modelWidth / 1.6 - deviation), (modelHeight / 1.6 - deviation));
        model.lineTo((modelWidth / 1.6 - deviation), (modelHeight / 1.6 - deviation));
        model.lineTo((modelWidth / 1.6 - deviation), -(modelHeight / 1.6 - deviation));
        model.closePath();

        const delModel = new THREE.Path()
        delModel.moveTo(-(modelWidth / 1.6 - deviation - offset), -(modelHeight / 1.8 - deviation));
        delModel.lineTo(-(modelWidth / 1.6 - deviation - offset), (modelHeight / 2.5 - deviation));
        delModel.lineTo(-(modelWidth / 1.6 - deviation * 1.1 - offset), (modelHeight / 2.5 - deviation));
        delModel.bezierCurveTo(-(modelWidth / 1.6 - deviation * 1.1 - offset), (modelHeight / 2.5 - deviation),
                                0, (modelHeight / 1.2 - deviation),
                                (modelWidth / 1.6 - deviation * 1.1 - offset), (modelHeight / 2.5 - deviation))
        delModel.lineTo((modelWidth / 1.6 - deviation * 1.1 - offset), (modelHeight / 2.5 - deviation));
        delModel.lineTo((modelWidth / 1.6 - deviation - offset), (modelHeight / 2.5 - deviation));
        delModel.lineTo((modelWidth / 1.6 - deviation - offset), -(modelHeight / 1.8 - deviation));
        delModel.closePath();


        model.holes.push(delModel);

        return model;
    }

    const glassModel = () => {
        const deviation = 0.3

        const model = new THREE.Shape();
        model.moveTo(-(modelWidth / 1.6 - deviation), -(modelHeight / 1.6 - deviation));
        model.lineTo(-(modelWidth / 1.6 - deviation), (modelHeight / 1.6 - deviation));
        model.lineTo((modelWidth / 1.6 - deviation), (modelHeight / 1.6 - deviation));
        model.lineTo((modelWidth / 1.6 - deviation), -(modelHeight / 1.6 - deviation));
        model.closePath();

        return model;
    }

    return (
        <group>
            <mesh name='glass-outerModel' >
                <extrudeGeometry args={[outerModel(), extrudeSettings(0.01, 0.14, 0.14, 0, 1)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} />
            </mesh>
            <mesh name='glass-innerModel'>
                <extrudeGeometry args={[innerModel(), extrudeSettings(0.01, 0.14, 0.14, 0, 1)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} />
            </mesh>
            <mesh name='glass' position={[0, 0, -0.1]}>
                <extrudeGeometry args={[glassModel(), extrudeSettings(0.2)]} />
                <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
            </mesh>
        </group>
    )
}